'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.recordAttributionAnalytics = exports.trackUpcomingCatalogClick = exports.trackTrendingItemClick = exports.trackFeaturedCategoryClick = exports.trackFeaturedCatalogClick = exports.trackHeroClick = exports.trackACNClick = exports.trackClick = exports.recordAnalyticsForMobilePageView = exports.recordAnalyticsForPRServicesPageView = exports.recordAnalyticsForIntellectualPropertyPageView = exports.recordAnalyticsForTerminologyPageView = exports.recordAnalyticsForTermsAndConditionsPageView = exports.recordAnalyticsForSearchItemsPageView = exports.recordAnalyticsForSellerPageView = exports.recordAnalyticsForSellerTestimonialsPageView = exports.recordAnalyticsForSellerDirectoryPageView = exports.recordAnalyticsForNearMePageView = exports.recordAnalyticsForMessagesPageView = exports.recordAnalyticsForSavedSearchesPageView = exports.recordAnalyticsForSavedItemsPageView = exports.recordAnalyticsForPrivacyPageView = exports.recordAnalyticsForMyAuctionsPageView = exports.recordAnalyticsForMyBidsPageView = exports.recordAnalyticsForItemPageView = undefined;
exports.recordAnalyticsForIdentify = exports.recordAnalyticsForHowItWorksPageView = exports.recordAnalyticsForHomePageView = exports.recordAnalyticsForFollowedSellersPageView = exports.recordAnalyticsForConsignmentsPageView = exports.recordAnalyticsForFeaturesPageView = exports.recordAnalyticsForCategoryLandingPageView = exports.recordAnalyticsForBidConsolePageView = exports.recordAnalyticsForCatalogPageView = exports.recordAnalyticsForAuctionResultsPageView = exports.recordAnalyticsForAccountSettingsPageView = exports.recordAnalyticsForAboutUsPageView = exports.getRetractedAbsenteeBidAnalytics = exports.getPlacedAbsenteeBidAnalytics = exports.getRequestedAuctionRegistrationAnalytics = exports.getLoginAnalytics = exports.getSetPasswordAnalytics = exports.getRegisterAccountAnalytics = exports.getCompleteAccountAnalytics = exports.getUnfollowSellerAnalytics = exports.getFollowSellerAnalytics = exports.getUnfollowSearchAnalytics = exports.getFollowSearchAnalytics = exports.getUnsaveItemAnalytics = exports.getSaveItemAnalytics = exports.getAttributionData = exports.SET_PASSWORD = exports.UNSAVE_ITEM = exports.UNFOLLOW_SELLER = exports.UNFOLLOW_SEARCH = exports.SAVE_ITEM = exports.RETRACTED_ABSENTEE_BID = exports.REQUESTED_AUCTION_REGISTRATION = exports.REGISTER_ACCOUNT = exports.PLACED_ABSENTEE_BID = exports.FOLLOW_SELLER = exports.FOLLOW_SEARCH = exports.COMPLETE_ACCOUNT = exports.TRACK_CLICK = exports.TRACK_ATTRIBUTION_DATA = exports.PAGEVIEW_PR_SERVICES_ANALYTICS = exports.PAGEVIEW_INTELLECTUAL_PROPERTY_ANALYTICS = exports.PAGEVIEW_TERMINOLOGY_ANALYTICS = exports.PAGEVIEW_TERMS_AND_CONDITIONS_ANALYTICS = exports.PAGEVIEW_SELLER_TESTIMONIALS_ANALYTICS = exports.PAGEVIEW_SELLER_DIRECTORY_ANALYTICS = exports.PAGEVIEW_SELLER_ANALYTICS = exports.PAGEVIEW_SEARCH_ITEMS_ANALYTICS = exports.PAGEVIEW_SAVED_SEARCHES_ANALYTICS = exports.PAGEVIEW_SAVED_ITEMS_ANALYTICS = exports.PAGEVIEW_PRIVACY_ANALYTICS = exports.PAGEVIEW_NEAR_ME_ANALYTICS = exports.PAGEVIEW_MY_BIDS_ANALYTICS = exports.PAGEVIEW_MY_AUCTIONS_ANALYTICS = exports.PAGEVIEW_MOBILE_ANALYTICS = exports.PAGEVIEW_MESSAGES_ANALYTICS = exports.PAGEVIEW_ITEM_ANALYTICS = exports.PAGEVIEW_HOW_IT_WORKS_ANALYTICS = exports.PAGEVIEW_HOME_ANALYTICS = exports.PAGEVIEW_FOLLOWED_SELLERS_ANALYTICS = exports.PAGEVIEW_FEATURES_ANALYTICS = exports.PAGEVIEW_CONSIGNMENTS_ANALYTICS = exports.PAGEVIEW_CATEGORY_ANALYTICS = exports.PAGEVIEW_CATALOG_ANALYTICS = exports.PAGEVIEW_BIDDING_CONSOLE_ANALYTICS = exports.PAGEVIEW_AUCTION_RESULTS_ANALYTICS = exports.PAGEVIEW_ACCOUNT_SETTINGS_ANALYTICS = exports.PAGEVIEW_ABOUT_US_ANALYTICS = exports.IDENTIFY_ANALYTICS = exports.PR_SERVICES_PAGE = exports.INTELLECTUAL_PROPERTY_PAGE = exports.TERMINOLOGY_PAGE = exports.TERMS_AND_CONDITIONS_PAGE = exports.SOLD_ITEM_PAGE = exports.SELLER_TESTIMONIALS_PAGE = exports.SEARCH_PAGE = exports.SAVED_SEARCHES_PAGE_MANAGE_TAB = exports.SAVED_SEARCHES_PAGE_RECENT_TAB = exports.SAVED_SEARCHES_PAGE = exports.SAVED_ITEMS_PAGE = exports.PRIVACY_PAGE = exports.NEAR_ME_PAGE = exports.MY_BIDS_PAGE = exports.MY_AUCTIONS_PAGE = exports.MOBILE_PAGE = exports.MESSAGES_PAGE = exports.ITEM_PAGE = exports.HOW_IT_WORKS_PAGE = exports.HOME_PAGE = exports.FOLLOWED_SELLERS_PAGE = exports.FEATURES_PAGE = exports.DIRECTORY_PAGE = exports.CONSIGNMENTS_PAGE = exports.CATEGORYLANDING_PAGE = exports.CATALOG_PAGE = exports.BIDDING_CONSOLE_PAGE = exports.AUCTIONEER_PAGE = exports.AUCTION_RESULTS_PAGE = exports.ACCOUNT_SETTINGS_PAGE = exports.ABOUT_US_PAGE = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _user = require('../modules/user');

var _urls = require('../../utils/urls');

var _route = require('./route');

var _reduxSegment = require('redux-segment');

var _config = require('../../redux/modules/config');

var _biddingInfo = require('../modules/biddingInfo');

var _catalog = require('../modules/catalog');

var _categoryGrabber = require('../../utils/categoryGrabber');

var _item = require('../modules/item');

var _itemFacets = require('../modules/itemFacets');

var _seller = require('../modules/seller');

var _catalogRegistration = require('../modules/catalogRegistration');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ABOUT_US_PAGE = exports.ABOUT_US_PAGE = 'about us';
var ACCOUNT_SETTINGS_PAGE = exports.ACCOUNT_SETTINGS_PAGE = 'account settings';
var AUCTION_RESULTS_PAGE = exports.AUCTION_RESULTS_PAGE = 'auction results';
var AUCTIONEER_PAGE = exports.AUCTIONEER_PAGE = 'auctioneer';
var BIDDING_CONSOLE_PAGE = exports.BIDDING_CONSOLE_PAGE = 'bidding console';
var CATALOG_PAGE = exports.CATALOG_PAGE = 'catalog';
var CATEGORYLANDING_PAGE = exports.CATEGORYLANDING_PAGE = 'category';
var CONSIGNMENTS_PAGE = exports.CONSIGNMENTS_PAGE = 'consignments';
var DIRECTORY_PAGE = exports.DIRECTORY_PAGE = 'directory';
var FEATURES_PAGE = exports.FEATURES_PAGE = 'features';
var FOLLOWED_SELLERS_PAGE = exports.FOLLOWED_SELLERS_PAGE = 'followed sellers';
var HOME_PAGE = exports.HOME_PAGE = 'home';
var HOW_IT_WORKS_PAGE = exports.HOW_IT_WORKS_PAGE = 'how it works';
var ITEM_PAGE = exports.ITEM_PAGE = 'item';
var MESSAGES_PAGE = exports.MESSAGES_PAGE = 'messages';
var MOBILE_PAGE = exports.MOBILE_PAGE = 'mobile';
var MY_AUCTIONS_PAGE = exports.MY_AUCTIONS_PAGE = 'my auctions';
var MY_BIDS_PAGE = exports.MY_BIDS_PAGE = 'my bids';
var NEAR_ME_PAGE = exports.NEAR_ME_PAGE = 'near me';
var PRIVACY_PAGE = exports.PRIVACY_PAGE = 'privacy';
var SAVED_ITEMS_PAGE = exports.SAVED_ITEMS_PAGE = 'saved items';
var SAVED_SEARCHES_PAGE = exports.SAVED_SEARCHES_PAGE = 'saved searches';
var SAVED_SEARCHES_PAGE_RECENT_TAB = exports.SAVED_SEARCHES_PAGE_RECENT_TAB = 'saved searches - manage tab';
var SAVED_SEARCHES_PAGE_MANAGE_TAB = exports.SAVED_SEARCHES_PAGE_MANAGE_TAB = 'saved searches - recent tab';
var SEARCH_PAGE = exports.SEARCH_PAGE = 'search';
var SELLER_TESTIMONIALS_PAGE = exports.SELLER_TESTIMONIALS_PAGE = 'testimonials';
var SOLD_ITEM_PAGE = exports.SOLD_ITEM_PAGE = 'sold item';
var TERMS_AND_CONDITIONS_PAGE = exports.TERMS_AND_CONDITIONS_PAGE = 'terms and conditions';
var TERMINOLOGY_PAGE = exports.TERMINOLOGY_PAGE = 'terminology';
var INTELLECTUAL_PROPERTY_PAGE = exports.INTELLECTUAL_PROPERTY_PAGE = 'intellectual property';
var PR_SERVICES_PAGE = exports.PR_SERVICES_PAGE = 'pr services';

var KNOWN_SEARCH_ENGINES = ['.msn.', '.search.com', 'about.com', 'adsensecustomsearchads.com', 'alice.', 'alltheweb.com', 'altavista.com', 'ask.com', 'avg.com', 'babylon.com', 'baidu.', 'biglobe.', 'bing.', 'centrum.cz', 'cnn.com/search', 'daum.net', 'delta-search.com', 'discretesearch.com', 'duckduckgo.com', 'easydialsearch.com', 'ekolay.net', 'eniro.se', 'haosou.com', 'kvasir.no', 'lycos.', 'mamma.com', 'mynet.com', 'myprivatesearch.com', 'mysearchdial.com', 'najdi.', 'naver.com', 'onet.pl', 'onetcenter.', 'ozu.es', 'pchome.com', 'query.searchdconvertnow.com', 'rakuten.', 'rambler.ru', 'search.aol', 'search.avira.net', 'search.bt.com', 'search.centurylink.com', 'search.colonymt.com', 'search.earthlink.net', 'search.excite.com', 'search.frontier.com', 'search.media.telstra.com', 'search.mediacomcable.com', 'search.monstercrawler.com', 'search.myway.com', 'search.pch.com', 'search.smt.docomo', 'search.socialdownloadr.com', 'search.twcc.com', 'search.us.com', 'search.xfinity.com', 'search.yahoo.com', 'searchall.com', 'searchassist.verizon.com', 'searchguide.windstream.net', 'searchlock.com', 'searchprivacy.co', 'searcht.sosodesktop.com', 'searchthis.com', 'securesearch.co', 'sesam.no', 'seznam.cz', 'so.com', 'sogou.com', 'startsiden.no', 'szukacz.pl', 'terra.com', 'thesmartsearch.net', 'utorrent.inspsearch.com', 'virgilio.it', 'voila.fr', 'w.goo.ne.jp', 'w.google.', 'w.yahoo.com', 'wp.pl', 'www.delta-search.com', 'yam.com', 'yandex.', 'yoursearch.me', 'zdsearch.com'];
var KNOWN_SOCIAL_NETWORKS = ['pinterest.', 'twitter.', '/t.co', 'facebook.', 'yuku.', 'netvibes.', 'blogspot.', 'houzz.', 'polyvore.', 'youtube.', 'vk.com', 'paper.li', 'reddit.', 'addthis.', 'buzzfeed.', 'plus.google.', 'plus.url.google', 'ravelry', 'wikia.', 'wordpress.', 'blog.goo.ne', 'linkedin.', 'groups.google.', '.ning.', 'stackexchange.', 'stumbleupon.', 'tumblr.', 'typepad.', 'answers.yahoo.'];
var IGNORED_REFERRERS = ['liveauctioneers.', 'optimizely.', 'atlassian.', 'localhost', 'rainforestqa.'];

/* ACTION TYPES */
// const SET_ANONYMOUS_ID = 'SET_ANONYMOUS_ID';
var IDENTIFY_ANALYTICS = exports.IDENTIFY_ANALYTICS = 'IDENTIFY_ANALYTICS';
var PAGEVIEW_ABOUT_US_ANALYTICS = exports.PAGEVIEW_ABOUT_US_ANALYTICS = 'PAGEVIEW_ABOUT_US_ANALYTICS';
var PAGEVIEW_ACCOUNT_SETTINGS_ANALYTICS = exports.PAGEVIEW_ACCOUNT_SETTINGS_ANALYTICS = 'PAGEVIEW_ACCOUNT_SETTINGS_ANALYTICS';
var PAGEVIEW_AUCTION_RESULTS_ANALYTICS = exports.PAGEVIEW_AUCTION_RESULTS_ANALYTICS = 'PAGEVIEW_AUCTION_RESULTS_ANALYTICS';
var PAGEVIEW_BIDDING_CONSOLE_ANALYTICS = exports.PAGEVIEW_BIDDING_CONSOLE_ANALYTICS = 'PAGEVIEW_BIDDING_CONSOLE_ANALYTICS';
var PAGEVIEW_CATALOG_ANALYTICS = exports.PAGEVIEW_CATALOG_ANALYTICS = 'PAGEVIEW_CATALOG_ANALYTICS';
var PAGEVIEW_CATEGORY_ANALYTICS = exports.PAGEVIEW_CATEGORY_ANALYTICS = 'PAGEVIEW_CATEGORY_ANALYTICS';
var PAGEVIEW_CONSIGNMENTS_ANALYTICS = exports.PAGEVIEW_CONSIGNMENTS_ANALYTICS = 'PAGEVIEW_CATEGORY_ANALYTICS';
var PAGEVIEW_FEATURES_ANALYTICS = exports.PAGEVIEW_FEATURES_ANALYTICS = 'PAGEVIEW_FEATURES_ANALYTICS';
var PAGEVIEW_FOLLOWED_SELLERS_ANALYTICS = exports.PAGEVIEW_FOLLOWED_SELLERS_ANALYTICS = 'PAGEVIEW_FOLLOWED_SELLERS_ANALYTICS';
var PAGEVIEW_HOME_ANALYTICS = exports.PAGEVIEW_HOME_ANALYTICS = 'PAGEVIEW_HOME_ANALYTICS';
var PAGEVIEW_HOW_IT_WORKS_ANALYTICS = exports.PAGEVIEW_HOW_IT_WORKS_ANALYTICS = 'PAGEVIEW_HOW_IT_WORKS_ANALYTICS';
var PAGEVIEW_ITEM_ANALYTICS = exports.PAGEVIEW_ITEM_ANALYTICS = 'PAGEVIEW_ITEM_ANALYTICS';
var PAGEVIEW_MESSAGES_ANALYTICS = exports.PAGEVIEW_MESSAGES_ANALYTICS = 'PAGEVIEW_MESSAGES_ANALYTICS';
var PAGEVIEW_MOBILE_ANALYTICS = exports.PAGEVIEW_MOBILE_ANALYTICS = 'PAGEVIEW_MOBILE_ANALYTICS';
var PAGEVIEW_MY_AUCTIONS_ANALYTICS = exports.PAGEVIEW_MY_AUCTIONS_ANALYTICS = 'PAGEVIEW_MY_AUCTIONS_ANALYTICS';
var PAGEVIEW_MY_BIDS_ANALYTICS = exports.PAGEVIEW_MY_BIDS_ANALYTICS = 'PAGEVIEW_MY_BIDS_ANALYTICS';
var PAGEVIEW_NEAR_ME_ANALYTICS = exports.PAGEVIEW_NEAR_ME_ANALYTICS = 'PAGEVIEW_NEAR_ME_ANALYTICS';
var PAGEVIEW_PRIVACY_ANALYTICS = exports.PAGEVIEW_PRIVACY_ANALYTICS = 'PAGEVIEW_PRIVACY_ANALYTICS';
var PAGEVIEW_SAVED_ITEMS_ANALYTICS = exports.PAGEVIEW_SAVED_ITEMS_ANALYTICS = 'PAGEVIEW_SAVED_ITEMS_ANALYTICS';
var PAGEVIEW_SAVED_SEARCHES_ANALYTICS = exports.PAGEVIEW_SAVED_SEARCHES_ANALYTICS = 'PAGEVIEW_SAVED_SEARCHES_ANALYTICS';
var PAGEVIEW_SEARCH_ITEMS_ANALYTICS = exports.PAGEVIEW_SEARCH_ITEMS_ANALYTICS = 'PAGEVIEW_SEARCH_ITEMS_ANALYTICS';
var PAGEVIEW_SELLER_ANALYTICS = exports.PAGEVIEW_SELLER_ANALYTICS = 'PAGEVIEW_SELLER_ANALYTICS';
var PAGEVIEW_SELLER_DIRECTORY_ANALYTICS = exports.PAGEVIEW_SELLER_DIRECTORY_ANALYTICS = 'PAGEVIEW_SELLER_DIRECTORY_ANALYTICS';
var PAGEVIEW_SELLER_TESTIMONIALS_ANALYTICS = exports.PAGEVIEW_SELLER_TESTIMONIALS_ANALYTICS = 'PAGEVIEW_SELLER_TESTIMONIALS_ANALYTICS';
var PAGEVIEW_TERMS_AND_CONDITIONS_ANALYTICS = exports.PAGEVIEW_TERMS_AND_CONDITIONS_ANALYTICS = 'PAGEVIEW_TERMS_AND_CONDITIONS_ANALYTICS';
var PAGEVIEW_TERMINOLOGY_ANALYTICS = exports.PAGEVIEW_TERMINOLOGY_ANALYTICS = 'PAGEVIEW_TERMINOLOGY_ANALYTICS';
var PAGEVIEW_INTELLECTUAL_PROPERTY_ANALYTICS = exports.PAGEVIEW_INTELLECTUAL_PROPERTY_ANALYTICS = 'PAGEVIEW_TERMINOLOGY_ANALYTICS';
var PAGEVIEW_PR_SERVICES_ANALYTICS = exports.PAGEVIEW_PR_SERVICES_ANALYTICS = 'PAGEVIEW_PR_SERVICES_ANALYTICS';
var TRACK_ATTRIBUTION_DATA = exports.TRACK_ATTRIBUTION_DATA = 'TRACK_ATTRIBUTION_DATA';
var TRACK_CLICK = exports.TRACK_CLICK = 'TRACK_CLICK';

/* ANALYTIC TYPES */
var COMPLETE_ACCOUNT = exports.COMPLETE_ACCOUNT = 'Completed Profile';
var FOLLOW_SEARCH = exports.FOLLOW_SEARCH = 'Followed Search';
var FOLLOW_SELLER = exports.FOLLOW_SELLER = 'Followed Auctioneer';
var PLACED_ABSENTEE_BID = exports.PLACED_ABSENTEE_BID = 'Placed Absentee Bid';
var REGISTER_ACCOUNT = exports.REGISTER_ACCOUNT = 'Registered Account';
var REQUESTED_AUCTION_REGISTRATION = exports.REQUESTED_AUCTION_REGISTRATION = 'Requested Auction Registration';
var RETRACTED_ABSENTEE_BID = exports.RETRACTED_ABSENTEE_BID = 'Retracted abstentee bid';
var SAVE_ITEM = exports.SAVE_ITEM = 'Saved Item';
var UNFOLLOW_SEARCH = exports.UNFOLLOW_SEARCH = 'Unfollowed Search';
var UNFOLLOW_SELLER = exports.UNFOLLOW_SELLER = 'Unfollowed Auctioneer';
var UNSAVE_ITEM = exports.UNSAVE_ITEM = 'Unsaved Item';
var SET_PASSWORD = exports.SET_PASSWORD = 'Set Password';

// reducer
var DEFAULT_STATE = {
    anonymousId: '',
    attributionData: {
        bidderId: 0,
        campaign: 'Placeholder campaign Data',
        content: 'Placeholder content Data',
        keyword: 'Placeholder keyword Data',
        medium: 'Placeholder medium Data',
        source: 'Placeholder source Data',
        touchDate: 0
    },
    referrer: ''
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case TRACK_ATTRIBUTION_DATA:
        default:
            return state;
    }
}

/* SELECTORS */
var getReferrer = function getReferrer(state) {
    return state.ui.analytics.referrer;
};

var getSailthru = function getSailthru() {
    return typeof window !== 'undefined' ? window.Sailthru : function () {
        return false;
    };
};

var getTouchDate = function getTouchDate(state) {
    return state.ui.analytics.touchDate;
};

var parseQuery = function parseQuery(qstr) {
    var query = {};
    var y = (qstr[0] === '?' ? qstr.substr(1) : qstr).split('?');
    var a = y[1].split('&');
    for (var i = 0; i < a.length; i += 1) {
        var b = a[i].split('=');
        query[decodeURIComponent(b[0]).toLowerCase()] = decodeURIComponent(b[1] || '');
    }
    return query;
};

var searchList = function searchList(haystack, needle) {
    var ret = -1;
    haystack.forEach(function (value) {
        if (needle.toLowerCase().includes(value)) {
            ret = needle;
        }
    });
    return ret;
};

var recursiveDecodeURI = function recursiveDecodeURI(URL) {
    try {
        var generatedURL = decodeURIComponent(URL);
        if (URL.length !== generatedURL.length) {
            return recursiveDecodeURI(generatedURL);
        }
    } catch (error) {
        console.error(error, URL);
    }
    return URL;
};

var getAttributionData = exports.getAttributionData = function getAttributionData(state) {
    var baseURL = (0, _config.getBaseUrl)(state);
    var currentUrl = recursiveDecodeURI((0, _route.getCurrentUrlFromState)(state, baseURL));
    var rawReferrer = getReferrer(state);
    var referrer = (0, _urls.separateURL)(rawReferrer);
    var bidderId = (0, _user.getBidderId)(state);
    var touchDate = getTouchDate(state);

    var attributionData = {
        bidderId: bidderId,
        campaign: '',
        content: '',
        keyword: '',
        medium: '',
        source: '',
        touchDate: touchDate
    };

    var engineName = searchList(KNOWN_SEARCH_ENGINES, rawReferrer);
    var networkName = searchList(KNOWN_SOCIAL_NETWORKS, rawReferrer);
    var referrerName = searchList(IGNORED_REFERRERS, rawReferrer);
    if (currentUrl.toLowerCase().includes('gclid')) {
        var queryObject = parseQuery(currentUrl);
        attributionData = (0, _extends3.default)({}, attributionData, {
            campaign: 'adwords',
            content: 'adwords',
            keyword: queryObject.gclid,
            medium: 'cpc',
            source: 'google'
        });
    } else if (currentUrl.toLowerCase().includes('gclsrc')) {
        var _queryObject = parseQuery(currentUrl);
        attributionData = (0, _extends3.default)({}, attributionData, {
            campaign: 'DoubleClick',
            content: 'DoubleClick',
            keyword: _queryObject.gclsrc || '',
            medium: 'cpc',
            source: 'google'
        });
    } else if (currentUrl.toLowerCase().includes('campaignsource')) {
        var _queryObject2 = parseQuery(currentUrl);
        attributionData = (0, _extends3.default)({}, attributionData, {
            campaign: _queryObject2.campaignname || '',
            content: _queryObject2.campaigncontent || '',
            keyword: _queryObject2.campaignkeyword || '',
            medium: _queryObject2.campaignmedium || '',
            source: _queryObject2.campaignsource || ''
        });
    } else if (currentUrl.toLowerCase().includes('utm_source')) {
        var _queryObject3 = parseQuery(currentUrl);
        attributionData = (0, _extends3.default)({}, attributionData, {
            campaign: _queryObject3.utm_campaign || '',
            content: _queryObject3.utm_content || '',
            keyword: _queryObject3.utm_term || '',
            medium: _queryObject3.utm_medium || '',
            source: _queryObject3.utm_source || ''
        });
    } else if (engineName !== -1) {
        attributionData = (0, _extends3.default)({}, attributionData, {
            content: referrer.path,
            medium: 'organic',
            source: referrer.host
        });
    } else if (networkName !== -1) {
        attributionData = (0, _extends3.default)({}, attributionData, {
            content: referrer.path,
            medium: 'social',
            source: referrer.host
        });
    } else if (referrer.host !== '' && referrerName === -1) {
        attributionData = (0, _extends3.default)({}, attributionData, {
            content: referrer.path,
            medium: 'referral',
            source: referrer.host
        });
    } else {
        attributionData = (0, _extends3.default)({}, attributionData, {
            campaign: 'direct',
            source: 'direct'
        });
    }
    return attributionData;
};

var getItemPrice = function getItemPrice(salePrice, leadingBid) {
    return salePrice || leadingBid;
};

var mapCategoryNames = function mapCategoryNames(facets) {
    for (var prop in facets) {
        if (Object.prototype.hasOwnProperty.call(facets, prop)) {
            facets[prop] = facets[prop].map(function (facet) {
                var facetLevel = (0, _categoryGrabber.getCategoryLevel)(facet);
                if (facetLevel.categoryName) {
                    return facetLevel.categoryName;
                }
                return facet;
            });
        }
    }
    return facets;
};

var getItemAnalytics = function getItemAnalytics(state, itemId, event) {
    var item = (0, _item.getItem)(state, itemId);
    var itemFacets = (0, _itemFacets.getItemFacets)(state, itemId);
    var facets = mapCategoryNames(itemFacets);
    var catalog = (0, _catalog.getCatalog)(state, item.catalogId);

    var _getBiddingInfo = (0, _biddingInfo.getBiddingInfo)(state, itemId),
        leadingBid = _getBiddingInfo.leadingBid;

    var salePrice = item.salePrice,
        houseId = item.houseId,
        title = item.title;
    var buyersPremium = catalog.buyersPremium,
        catalogId = catalog.catalogId,
        catalogStatus = catalog.catalogStatus;
    var _facets$categories = facets.categories,
        categories = _facets$categories === undefined ? 'n/a' : _facets$categories,
        _facets$creators = facets.creators,
        creators = _facets$creators === undefined ? 'n/a' : _facets$creators,
        _facets$materialsTech = facets.materialsTechniques,
        materialsTechniques = _facets$materialsTech === undefined ? 'n/a' : _facets$materialsTech,
        _facets$origins = facets.origins,
        origins = _facets$origins === undefined ? 'n/a' : _facets$origins,
        _facets$stylePeriods = facets.stylePeriods,
        stylePeriods = _facets$stylePeriods === undefined ? 'n/a' : _facets$stylePeriods;


    var price = getItemPrice(salePrice, leadingBid);

    var formatAnalytics = {
        analytics: {
            eventPayload: {
                event: event,
                properties: {
                    buyersPremium: buyersPremium,
                    catalogId: catalogId,
                    catalogStatus: catalogStatus,
                    categories: categories,
                    creators: creators,
                    houseId: houseId,
                    itemId: itemId,
                    materialsTechniques: materialsTechniques,
                    origins: origins,
                    price: price,
                    stylePeriods: stylePeriods,
                    title: title
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
    return formatAnalytics;
};

var getSaveItemAnalytics = exports.getSaveItemAnalytics = function getSaveItemAnalytics(state, itemId) {
    return getItemAnalytics(state, itemId, SAVE_ITEM);
};

var getUnsaveItemAnalytics = exports.getUnsaveItemAnalytics = function getUnsaveItemAnalytics(state, itemId) {
    return getItemAnalytics(state, itemId, UNSAVE_ITEM);
};

var getSellerAnalytics = function getSellerAnalytics(sellerId, event) {
    return {
        analytics: {
            eventPayload: {
                event: event,
                properties: {
                    houseId: sellerId
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
};
var getFollowSearchAnalytics = exports.getFollowSearchAnalytics = function getFollowSearchAnalytics() {
    return {
        analytics: {
            eventPayload: {
                event: FOLLOW_SEARCH
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
};
var getUnfollowSearchAnalytics = exports.getUnfollowSearchAnalytics = function getUnfollowSearchAnalytics() {
    return {
        analytics: {
            eventPayload: {
                event: UNFOLLOW_SEARCH
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
};
var getFollowSellerAnalytics = exports.getFollowSellerAnalytics = function getFollowSellerAnalytics(sellerId) {
    return getSellerAnalytics(sellerId, FOLLOW_SELLER);
};

var getUnfollowSellerAnalytics = exports.getUnfollowSellerAnalytics = function getUnfollowSellerAnalytics(sellerId) {
    return getSellerAnalytics(sellerId, UNFOLLOW_SELLER);
};

var getCompleteAccountAnalytics = exports.getCompleteAccountAnalytics = function getCompleteAccountAnalytics() {
    return {
        analytics: {
            eventPayload: {
                event: COMPLETE_ACCOUNT
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
};

var registerAnalytics = function registerAnalytics(bidderId, attributionData, event) {
    return {
        analytics: [{
            eventPayload: {
                event: event,
                properties: {
                    attribution_bidderId: bidderId,
                    attribution_campaign: attributionData.campaign,
                    attribution_content: attributionData.content,
                    attribution_keyword: attributionData.keyword,
                    attribution_medium: attributionData.medium,
                    attribution_source: attributionData.source,
                    attribution_touchdate: attributionData.touchDate
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }]
    };
};

var getRegisterAccountAnalytics = exports.getRegisterAccountAnalytics = function getRegisterAccountAnalytics(bidderId, attributionData) {
    return registerAnalytics(bidderId, attributionData, REGISTER_ACCOUNT);
};

var getSetPasswordAnalytics = exports.getSetPasswordAnalytics = function getSetPasswordAnalytics(bidderId, attributionData) {
    return registerAnalytics(bidderId, attributionData, SET_PASSWORD);
};

var getLoginAnalytics = exports.getLoginAnalytics = function getLoginAnalytics(loginData) {
    return {
        analytics: {
            eventPayload: {
                traits: {
                    annualNms: loginData.annualNMS,
                    createdAt: loginData.bidder.createdDate,
                    creditCardValidated: loginData.bidder.creditCardValidated,
                    email: loginData.bidder.email,
                    firstName: loginData.bidder.firstName,
                    lastName: loginData.bidder.lastName,
                    profileComplete: loginData.bidder.profileComplete
                },
                userId: loginData.bidder.bidderId
            },
            eventType: _reduxSegment.EventTypes.identify
        }
    };
};

var getRequestedAuctionRegistrationAnalytics = exports.getRequestedAuctionRegistrationAnalytics = function getRequestedAuctionRegistrationAnalytics(state, catalogId) {
    // TODO: this is gross and needs to be refactored once we have catalogs in the
    // store, but for now it will work
    var _ref = (0, _catalog.getCatalog)(state, catalogId) || {},
        catalogStatus = _ref.catalogStatus,
        sellerId = _ref.sellerId;

    var auctionAnalytics = {
        analytics: {
            eventPayload: {
                event: REQUESTED_AUCTION_REGISTRATION,
                properties: {
                    catalogId: catalogId,
                    catalogStatus: catalogStatus,
                    sellerId: sellerId
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
    return auctionAnalytics;
};

var getPlacedAbsenteeBidAnalytics = exports.getPlacedAbsenteeBidAnalytics = function getPlacedAbsenteeBidAnalytics(state, itemId, bidAmount) {
    // TODO: we need to decide what the proper definition of 'bidCount' is and then implement
    var _getItem = (0, _item.getItem)(state, itemId),
        catalogId = _getItem.catalogId,
        salePrice = _getItem.salePrice,
        houseId = _getItem.houseId,
        title = _getItem.title;

    var _getCatalog = (0, _catalog.getCatalog)(state, catalogId),
        buyersPremium = _getCatalog.buyersPremium,
        catalogStatus = _getCatalog.catalogStatus,
        currency = _getCatalog.currency;

    var _getBiddingInfo2 = (0, _biddingInfo.getBiddingInfo)(state, itemId),
        leadingBid = _getBiddingInfo2.leadingBid;

    var approvedForAuction = (0, _catalogRegistration.getUserCatalogRegistration)(state, catalogId).approved;
    var userData = (0, _user.getUserData)(state);
    var bidderId = userData.bidderId;
    var price = getItemPrice(salePrice, leadingBid);
    // const bidCount = 1;
    var formatAnalytics = {
        analytics: {
            eventPayload: {
                event: PLACED_ABSENTEE_BID,
                properties: {
                    approvedForAuction: approvedForAuction,
                    // bidCount,
                    biddingStatus: 'absentee',
                    buyersPremium: buyersPremium,
                    catalogId: catalogId,
                    catalogStatus: catalogStatus,
                    currency: currency,
                    houseId: houseId,
                    itemId: itemId,
                    orderId: itemId + '-' + bidderId,
                    products: [{
                        id: itemId,
                        name: title,
                        price: price,
                        quantity: 1
                    }],
                    total: bidAmount,
                    value: bidAmount
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };

    return formatAnalytics;
};

var getRetractedAbsenteeBidAnalytics = exports.getRetractedAbsenteeBidAnalytics = function getRetractedAbsenteeBidAnalytics(state, itemId, retractionReason, retractionExplanation) {
    var userData = (0, _user.getUserData)(state);
    var bidderId = userData.bidderId;

    var formatAnalytics = {
        analytics: {
            eventPayload: {
                event: RETRACTED_ABSENTEE_BID,
                properties: {
                    bidderId: bidderId,
                    itemId: itemId,
                    retractionExplanation: retractionExplanation,
                    retractionReason: retractionReason
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };

    return formatAnalytics;
};

/* ACTION CREATORS */
var sailthruTrack = function sailthruTrack(url) {
    var sailthru = getSailthru();
    if (sailthru) {
        var path = (0, _urls.separateURL)(url).path ? (0, _urls.separateURL)(url).path : url;
        var finalURL = 'https://www.liveauctioneers.com' + path;
        try {
            sailthru.track('pageview', {
                url: finalURL
            });
        } catch (e) {
            console.log('Edge thinks this method wants an object, but it\'s wrong!');
        }
    }
};

var recordAnalyticsForAboutUsPageView = exports.recordAnalyticsForAboutUsPageView = function recordAnalyticsForAboutUsPageView() {
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, baseUrl, currentUrl;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);


                            sailthruTrack(currentUrl);
                            return _context.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: ABOUT_US_PAGE,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_ABOUT_US_ANALYTICS
                            }));

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForAccountSettingsPageView = exports.recordAnalyticsForAccountSettingsPageView = function recordAnalyticsForAccountSettingsPageView() {
    return function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            var state, baseUrl, currentUrl;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);


                            sailthruTrack(currentUrl);
                            return _context2.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: ACCOUNT_SETTINGS_PAGE,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_ACCOUNT_SETTINGS_ANALYTICS
                            }));

                        case 5:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined);
        }));

        return function (_x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForAuctionResultsPageView = exports.recordAnalyticsForAuctionResultsPageView = function recordAnalyticsForAuctionResultsPageView() {
    return function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
            var state, baseUrl, currentUrl;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);


                            sailthruTrack(currentUrl);
                            return _context3.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: AUCTION_RESULTS_PAGE,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_AUCTION_RESULTS_ANALYTICS
                            }));

                        case 5:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, undefined);
        }));

        return function (_x7, _x8) {
            return _ref4.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForCatalogPageView = exports.recordAnalyticsForCatalogPageView = function recordAnalyticsForCatalogPageView(catalogId) {
    return function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch, getState) {
            var state, catalog, baseUrl, currentUrl, catalogStatus, saleStartTs, houseId, title, pathname;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            state = getState();
                            catalog = (0, _catalog.getCatalog)(state, catalogId);
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);
                            catalogStatus = catalog.catalogStatus, saleStartTs = catalog.saleStartTs, houseId = catalog.sellerId, title = catalog.title;
                            pathname = (0, _urls.getCatalogUrl)(catalogId, title);

                            sailthruTrack(currentUrl);
                            return _context4.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                catalogId: catalogId,
                                                catalogStatus: catalogStatus,
                                                houseId: houseId,
                                                pageType: CATALOG_PAGE,
                                                path: pathname,
                                                saleStartTs: saleStartTs,
                                                title: title,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_CATALOG_ANALYTICS
                            }));

                        case 8:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, undefined);
        }));

        return function (_x9, _x10) {
            return _ref5.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForBidConsolePageView = exports.recordAnalyticsForBidConsolePageView = function recordAnalyticsForBidConsolePageView(catalogId) {
    return function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch, getState) {
            var state, catalog, baseUrl, currentUrl, catalogStatus, saleStartTs, houseId, title, pathname;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            state = getState();
                            catalog = (0, _catalog.getCatalog)(state, catalogId);
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);
                            catalogStatus = catalog.catalogStatus, saleStartTs = catalog.saleStartTs, houseId = catalog.sellerId, title = catalog.title;
                            pathname = (0, _urls.getCatalogUrl)(catalogId, title);

                            sailthruTrack(currentUrl);
                            return _context5.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                catalogId: catalogId,
                                                catalogStatus: catalogStatus,
                                                houseId: houseId,
                                                pageType: BIDDING_CONSOLE_PAGE,
                                                path: pathname,
                                                saleStartTs: saleStartTs,
                                                title: title,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_BIDDING_CONSOLE_ANALYTICS
                            }));

                        case 8:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, undefined);
        }));

        return function (_x11, _x12) {
            return _ref6.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForCategoryLandingPageView = exports.recordAnalyticsForCategoryLandingPageView = function recordAnalyticsForCategoryLandingPageView() {
    return function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch, getState) {
            var state, _getCurrentUrl, pathname, pageType;

            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            state = getState();
                            _getCurrentUrl = (0, _route.getCurrentUrl)(state), pathname = _getCurrentUrl.pathname;
                            pageType = CATEGORYLANDING_PAGE;

                            sailthruTrack(pathname);
                            return _context6.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: pageType,
                                                path: pathname,
                                                url: pathname
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_CATEGORY_ANALYTICS
                            }));

                        case 5:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, undefined);
        }));

        return function (_x13, _x14) {
            return _ref7.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForFeaturesPageView = exports.recordAnalyticsForFeaturesPageView = function recordAnalyticsForFeaturesPageView() {
    return function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch, getState) {
            var state, baseUrl, currentUrl;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);


                            sailthruTrack(currentUrl);
                            return _context7.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: FEATURES_PAGE,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_FEATURES_ANALYTICS
                            }));

                        case 5:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, undefined);
        }));

        return function (_x15, _x16) {
            return _ref8.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForConsignmentsPageView = exports.recordAnalyticsForConsignmentsPageView = function recordAnalyticsForConsignmentsPageView() {
    return function () {
        var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(dispatch, getState) {
            var state, baseUrl, currentUrl;
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);

                            sailthruTrack(currentUrl);
                            return _context8.abrupt('return', {
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: CONSIGNMENTS_PAGE,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_CONSIGNMENTS_ANALYTICS
                            });

                        case 5:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, undefined);
        }));

        return function (_x17, _x18) {
            return _ref9.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForFollowedSellersPageView = exports.recordAnalyticsForFollowedSellersPageView = function recordAnalyticsForFollowedSellersPageView() {
    return function () {
        var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(dispatch, getState) {
            var state, baseUrl, currentUrl;
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);

                            sailthruTrack(currentUrl);
                            return _context9.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: FOLLOWED_SELLERS_PAGE,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_FOLLOWED_SELLERS_ANALYTICS
                            }));

                        case 5:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, undefined);
        }));

        return function (_x19, _x20) {
            return _ref10.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForHomePageView = exports.recordAnalyticsForHomePageView = function recordAnalyticsForHomePageView() {
    return function () {
        var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(dispatch, getState) {
            var state, baseUrl, currentUrl;
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);


                            sailthruTrack(currentUrl);
                            return _context10.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: HOME_PAGE,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_HOME_ANALYTICS
                            }));

                        case 5:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, undefined);
        }));

        return function (_x21, _x22) {
            return _ref11.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForHowItWorksPageView = exports.recordAnalyticsForHowItWorksPageView = function recordAnalyticsForHowItWorksPageView() {
    return function () {
        var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(dispatch, getState) {
            var state, baseUrl, currentUrl;
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);


                            sailthruTrack(currentUrl);
                            return _context11.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: HOW_IT_WORKS_PAGE,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_HOW_IT_WORKS_ANALYTICS
                            }));

                        case 5:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, undefined);
        }));

        return function (_x23, _x24) {
            return _ref12.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForIdentify = exports.recordAnalyticsForIdentify = function recordAnalyticsForIdentify(bidder) {
    return {
        meta: getLoginAnalytics(bidder),
        payload: {},
        type: IDENTIFY_ANALYTICS
    };
};

var recordAnalyticsForItemPageView = exports.recordAnalyticsForItemPageView = function recordAnalyticsForItemPageView(itemId) {
    return function () {
        var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(dispatch, getState) {
            var state, item, catalog, biddingInfo, facets, baseUrl, currentUrl, salePrice, houseId, title, buyersPremium, catalogId, catalogStatus, categories, creators, materialsTechniques, origins, stylePeriods, leadingBid, pathname, pageType;
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            state = getState();
                            item = (0, _item.getItem)(state, itemId);
                            catalog = (0, _catalog.getCatalog)(state, item.catalogId);
                            biddingInfo = (0, _biddingInfo.getBiddingInfo)(state, itemId);
                            facets = (0, _itemFacets.getItemFacets)(state, itemId);
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);
                            salePrice = item.salePrice, houseId = item.sellerId, title = item.title;
                            buyersPremium = catalog.buyersPremium, catalogId = catalog.catalogId, catalogStatus = catalog.catalogStatus;
                            categories = facets.categories, creators = facets.creators, materialsTechniques = facets.materialsTechniques, origins = facets.origins, stylePeriods = facets.stylePeriods;
                            leadingBid = biddingInfo.leadingBid;
                            pathname = (0, _urls.getItemUrl)(itemId, title);
                            pageType = catalogStatus === 'done' ? SOLD_ITEM_PAGE : ITEM_PAGE;

                            sailthruTrack(currentUrl);
                            return _context12.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                buyersPremium: buyersPremium,
                                                catalogId: catalogId,
                                                catalogStatus: catalogStatus,
                                                categories: categories,
                                                creators: creators,
                                                houseId: houseId,
                                                itemId: itemId,
                                                materialsTechniques: materialsTechniques,
                                                origins: origins,
                                                pageType: pageType,
                                                path: pathname,
                                                salePrice: salePrice || leadingBid,
                                                stylePeriods: stylePeriods,
                                                title: title,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_ITEM_ANALYTICS
                            }));

                        case 15:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, undefined);
        }));

        return function (_x25, _x26) {
            return _ref13.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForMyBidsPageView = exports.recordAnalyticsForMyBidsPageView = function recordAnalyticsForMyBidsPageView() {
    return function () {
        var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(dispatch, getState) {
            var state, baseUrl, currentUrl, pathname, pageType;
            return _regenerator2.default.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);
                            pathname = (0, _urls.getMyBidsUrl)();
                            pageType = MY_BIDS_PAGE;

                            sailthruTrack(currentUrl);
                            return _context13.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: pageType,
                                                path: pathname,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_MY_BIDS_ANALYTICS
                            }));

                        case 7:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, undefined);
        }));

        return function (_x27, _x28) {
            return _ref14.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForMyAuctionsPageView = exports.recordAnalyticsForMyAuctionsPageView = function recordAnalyticsForMyAuctionsPageView() {
    return function () {
        var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(dispatch, getState) {
            var state, baseUrl, currentUrl, pathname, pageType;
            return _regenerator2.default.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);
                            pathname = (0, _urls.getMyAuctionsUrl)();
                            pageType = MY_AUCTIONS_PAGE;

                            sailthruTrack(currentUrl);
                            return _context14.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: pageType,
                                                path: pathname,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_MY_AUCTIONS_ANALYTICS
                            }));

                        case 7:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, undefined);
        }));

        return function (_x29, _x30) {
            return _ref15.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForPrivacyPageView = exports.recordAnalyticsForPrivacyPageView = function recordAnalyticsForPrivacyPageView() {
    return function () {
        var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(dispatch, getState) {
            var state, baseUrl, currentUrl;
            return _regenerator2.default.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);


                            sailthruTrack(currentUrl);
                            return _context15.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: PRIVACY_PAGE,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_PRIVACY_ANALYTICS
                            }));

                        case 5:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, undefined);
        }));

        return function (_x31, _x32) {
            return _ref16.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForSavedItemsPageView = exports.recordAnalyticsForSavedItemsPageView = function recordAnalyticsForSavedItemsPageView() {
    return function () {
        var _ref17 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16(dispatch, getState) {
            var state, baseUrl, currentUrl, pathname, pageType;
            return _regenerator2.default.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);
                            pathname = (0, _urls.getSavedItemsUrl)();
                            pageType = SAVED_ITEMS_PAGE;

                            sailthruTrack(currentUrl);
                            return _context16.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: pageType,
                                                path: pathname,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_SAVED_ITEMS_ANALYTICS
                            }));

                        case 7:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, undefined);
        }));

        return function (_x33, _x34) {
            return _ref17.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForSavedSearchesPageView = exports.recordAnalyticsForSavedSearchesPageView = function recordAnalyticsForSavedSearchesPageView(pageType) {
    return function () {
        var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17(dispatch, getState) {
            var state, baseUrl, currentUrl;
            return _regenerator2.default.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);


                            sailthruTrack(currentUrl);
                            return _context17.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: pageType,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_SAVED_SEARCHES_ANALYTICS
                            }));

                        case 5:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, undefined);
        }));

        return function (_x35, _x36) {
            return _ref18.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForMessagesPageView = exports.recordAnalyticsForMessagesPageView = function recordAnalyticsForMessagesPageView() {
    return function () {
        var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18(dispatch, getState) {
            var state, baseUrl, currentUrl, pageType;
            return _regenerator2.default.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);
                            pageType = MESSAGES_PAGE;

                            sailthruTrack(currentUrl);
                            return _context18.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: pageType,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_MESSAGES_ANALYTICS
                            }));

                        case 6:
                        case 'end':
                            return _context18.stop();
                    }
                }
            }, _callee18, undefined);
        }));

        return function (_x37, _x38) {
            return _ref19.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForNearMePageView = exports.recordAnalyticsForNearMePageView = function recordAnalyticsForNearMePageView() {
    return function () {
        var _ref20 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19(dispatch, getState) {
            var state, baseUrl, currentUrl, pageType;
            return _regenerator2.default.wrap(function _callee19$(_context19) {
                while (1) {
                    switch (_context19.prev = _context19.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);
                            pageType = NEAR_ME_PAGE;

                            sailthruTrack(currentUrl);
                            return _context19.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: pageType,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_NEAR_ME_ANALYTICS
                            }));

                        case 6:
                        case 'end':
                            return _context19.stop();
                    }
                }
            }, _callee19, undefined);
        }));

        return function (_x39, _x40) {
            return _ref20.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForSellerDirectoryPageView = exports.recordAnalyticsForSellerDirectoryPageView = function recordAnalyticsForSellerDirectoryPageView() {
    return function () {
        var _ref21 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee20(dispatch, getState) {
            var state, baseUrl, currentUrl;
            return _regenerator2.default.wrap(function _callee20$(_context20) {
                while (1) {
                    switch (_context20.prev = _context20.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);


                            sailthruTrack(currentUrl);
                            return _context20.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: DIRECTORY_PAGE,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_SELLER_DIRECTORY_ANALYTICS
                            }));

                        case 5:
                        case 'end':
                            return _context20.stop();
                    }
                }
            }, _callee20, undefined);
        }));

        return function (_x41, _x42) {
            return _ref21.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForSellerTestimonialsPageView = exports.recordAnalyticsForSellerTestimonialsPageView = function recordAnalyticsForSellerTestimonialsPageView() {
    return function () {
        var _ref22 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee21(dispatch, getState) {
            var state, baseUrl, currentUrl;
            return _regenerator2.default.wrap(function _callee21$(_context21) {
                while (1) {
                    switch (_context21.prev = _context21.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);


                            sailthruTrack(currentUrl);
                            return _context21.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: SELLER_TESTIMONIALS_PAGE,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_SELLER_TESTIMONIALS_ANALYTICS
                            }));

                        case 5:
                        case 'end':
                            return _context21.stop();
                    }
                }
            }, _callee21, undefined);
        }));

        return function (_x43, _x44) {
            return _ref22.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForSellerPageView = exports.recordAnalyticsForSellerPageView = function recordAnalyticsForSellerPageView(sellerId) {
    return function () {
        var _ref23 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee22(dispatch, getState) {
            var state, baseUrl, currentUrl, seller, name, pageType, pathname;
            return _regenerator2.default.wrap(function _callee22$(_context22) {
                while (1) {
                    switch (_context22.prev = _context22.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);
                            seller = (0, _seller.getSeller)(state, sellerId);
                            name = seller.name;
                            pageType = AUCTIONEER_PAGE;
                            pathname = (0, _urls.getSellerUrl)(sellerId, name);

                            sailthruTrack(currentUrl);
                            return _context22.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                houseId: sellerId,
                                                name: name,
                                                pageType: pageType,
                                                path: pathname,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_SELLER_ANALYTICS
                            }));

                        case 9:
                        case 'end':
                            return _context22.stop();
                    }
                }
            }, _callee22, undefined);
        }));

        return function (_x45, _x46) {
            return _ref23.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForSearchItemsPageView = exports.recordAnalyticsForSearchItemsPageView = function recordAnalyticsForSearchItemsPageView() {
    return function () {
        var _ref24 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee23(dispatch, getState) {
            var state, _getCurrentUrl2, pathname, pageType;

            return _regenerator2.default.wrap(function _callee23$(_context23) {
                while (1) {
                    switch (_context23.prev = _context23.next) {
                        case 0:
                            state = getState();
                            _getCurrentUrl2 = (0, _route.getCurrentUrl)(state), pathname = _getCurrentUrl2.pathname;
                            pageType = SEARCH_PAGE;

                            sailthruTrack(pathname);
                            return _context23.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: pageType,
                                                path: pathname,
                                                url: pathname
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_SEARCH_ITEMS_ANALYTICS
                            }));

                        case 5:
                        case 'end':
                            return _context23.stop();
                    }
                }
            }, _callee23, undefined);
        }));

        return function (_x47, _x48) {
            return _ref24.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForTermsAndConditionsPageView = exports.recordAnalyticsForTermsAndConditionsPageView = function recordAnalyticsForTermsAndConditionsPageView() {
    return function () {
        var _ref25 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee24(dispatch, getState) {
            var state, baseUrl, currentUrl;
            return _regenerator2.default.wrap(function _callee24$(_context24) {
                while (1) {
                    switch (_context24.prev = _context24.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);


                            sailthruTrack(currentUrl);
                            return _context24.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: TERMS_AND_CONDITIONS_PAGE,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_TERMS_AND_CONDITIONS_ANALYTICS
                            }));

                        case 5:
                        case 'end':
                            return _context24.stop();
                    }
                }
            }, _callee24, undefined);
        }));

        return function (_x49, _x50) {
            return _ref25.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForTerminologyPageView = exports.recordAnalyticsForTerminologyPageView = function recordAnalyticsForTerminologyPageView() {
    return function () {
        var _ref26 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee25(dispatch, getState) {
            var state, baseUrl, currentUrl;
            return _regenerator2.default.wrap(function _callee25$(_context25) {
                while (1) {
                    switch (_context25.prev = _context25.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);


                            sailthruTrack(currentUrl);
                            return _context25.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: TERMINOLOGY_PAGE,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_TERMINOLOGY_ANALYTICS
                            }));

                        case 5:
                        case 'end':
                            return _context25.stop();
                    }
                }
            }, _callee25, undefined);
        }));

        return function (_x51, _x52) {
            return _ref26.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForIntellectualPropertyPageView = exports.recordAnalyticsForIntellectualPropertyPageView = function recordAnalyticsForIntellectualPropertyPageView() {
    return function () {
        var _ref27 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee26(dispatch, getState) {
            var state, baseUrl, currentUrl;
            return _regenerator2.default.wrap(function _callee26$(_context26) {
                while (1) {
                    switch (_context26.prev = _context26.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);


                            sailthruTrack(currentUrl);
                            return _context26.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: INTELLECTUAL_PROPERTY_PAGE,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_INTELLECTUAL_PROPERTY_ANALYTICS
                            }));

                        case 5:
                        case 'end':
                            return _context26.stop();
                    }
                }
            }, _callee26, undefined);
        }));

        return function (_x53, _x54) {
            return _ref27.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForPRServicesPageView = exports.recordAnalyticsForPRServicesPageView = function recordAnalyticsForPRServicesPageView() {
    return function () {
        var _ref28 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee27(dispatch, getState) {
            var state, baseUrl, currentUrl;
            return _regenerator2.default.wrap(function _callee27$(_context27) {
                while (1) {
                    switch (_context27.prev = _context27.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);


                            sailthruTrack(currentUrl);
                            return _context27.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: PR_SERVICES_PAGE,
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_PR_SERVICES_ANALYTICS
                            }));

                        case 5:
                        case 'end':
                            return _context27.stop();
                    }
                }
            }, _callee27, undefined);
        }));

        return function (_x55, _x56) {
            return _ref28.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForMobilePageView = exports.recordAnalyticsForMobilePageView = function recordAnalyticsForMobilePageView() {
    return function () {
        var _ref29 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee28(dispatch, getState) {
            var state, baseUrl, currentUrl;
            return _regenerator2.default.wrap(function _callee28$(_context28) {
                while (1) {
                    switch (_context28.prev = _context28.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);


                            sailthruTrack(currentUrl);
                            return _context28.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: {
                                                pageType: MOBILE_PAGE,
                                                path: '/mobile',
                                                url: currentUrl
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: PAGEVIEW_MOBILE_ANALYTICS
                            }));

                        case 5:
                        case 'end':
                            return _context28.stop();
                    }
                }
            }, _callee28, undefined);
        }));

        return function (_x57, _x58) {
            return _ref29.apply(this, arguments);
        };
    }();
};

var getGAEventAnalytics = function getGAEventAnalytics(action, category, label) {
    return {
        analytics: {
            eventPayload: {
                event: action,
                properties: {
                    action: action,
                    category: category,
                    label: label
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
};

var trackClick = exports.trackClick = function trackClick(action, label) {
    return function () {
        var _ref30 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee29(dispatch, getState) {
            var analytics;
            return _regenerator2.default.wrap(function _callee29$(_context29) {
                while (1) {
                    switch (_context29.prev = _context29.next) {
                        case 0:
                            analytics = getGAEventAnalytics(action, 'Navigation', label);
                            return _context29.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 2:
                        case 'end':
                            return _context29.stop();
                    }
                }
            }, _callee29, undefined);
        }));

        return function (_x59, _x60) {
            return _ref30.apply(this, arguments);
        };
    }();
};

var trackACNClick = exports.trackACNClick = function trackACNClick(label) {
    return function () {
        var _ref31 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee30(dispatch, getState) {
            var state, bidderId, action, labelToUse, analytics;
            return _regenerator2.default.wrap(function _callee30$(_context30) {
                while (1) {
                    switch (_context30.prev = _context30.next) {
                        case 0:
                            state = getState();
                            bidderId = (0, _user.getBidderId)(state);
                            action = 'Clicked Homepage ACN Module';
                            labelToUse = '' + label;

                            if (bidderId) {
                                labelToUse += '-' + bidderId;
                            }

                            analytics = getGAEventAnalytics(action, 'Navigation', labelToUse);
                            return _context30.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 7:
                        case 'end':
                            return _context30.stop();
                    }
                }
            }, _callee30, undefined);
        }));

        return function (_x61, _x62) {
            return _ref31.apply(this, arguments);
        };
    }();
};

var trackHeroClick = exports.trackHeroClick = function trackHeroClick(label) {
    return function () {
        var _ref32 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee31(dispatch, getState) {
            var state, bidderId, action, labelToUse, analytics;
            return _regenerator2.default.wrap(function _callee31$(_context31) {
                while (1) {
                    switch (_context31.prev = _context31.next) {
                        case 0:
                            state = getState();
                            bidderId = (0, _user.getBidderId)(state);
                            action = 'Clicked Homepage Hero Banner Module';
                            labelToUse = '' + label;

                            if (bidderId) {
                                labelToUse += '-' + bidderId;
                            }

                            analytics = getGAEventAnalytics(action, 'Navigation', labelToUse);
                            return _context31.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 7:
                        case 'end':
                            return _context31.stop();
                    }
                }
            }, _callee31, undefined);
        }));

        return function (_x63, _x64) {
            return _ref32.apply(this, arguments);
        };
    }();
};

var trackFeaturedCatalogClick = exports.trackFeaturedCatalogClick = function trackFeaturedCatalogClick(catalogId) {
    return function () {
        var _ref33 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee32(dispatch, getState) {
            var state, _getCatalog2, sellerId, bidderId, action, label, analytics;

            return _regenerator2.default.wrap(function _callee32$(_context32) {
                while (1) {
                    switch (_context32.prev = _context32.next) {
                        case 0:
                            state = getState();
                            _getCatalog2 = (0, _catalog.getCatalog)(state, catalogId), sellerId = _getCatalog2.sellerId;
                            bidderId = (0, _user.getBidderId)(state);
                            action = 'Clicked Homepage Featured Auctions Module';
                            label = 'featured-' + catalogId + '-' + sellerId;

                            if (bidderId) {
                                label += '-' + bidderId;
                            }

                            analytics = getGAEventAnalytics(action, 'Navigation', label);
                            return _context32.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 8:
                        case 'end':
                            return _context32.stop();
                    }
                }
            }, _callee32, undefined);
        }));

        return function (_x65, _x66) {
            return _ref33.apply(this, arguments);
        };
    }();
};

var trackFeaturedCategoryClick = exports.trackFeaturedCategoryClick = function trackFeaturedCategoryClick(label) {
    return function () {
        var _ref34 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee33(dispatch, getState) {
            var state, bidderId, action, labelToUse, analytics;
            return _regenerator2.default.wrap(function _callee33$(_context33) {
                while (1) {
                    switch (_context33.prev = _context33.next) {
                        case 0:
                            state = getState();
                            bidderId = (0, _user.getBidderId)(state);
                            action = 'Clicked Homepage Featured Categories Module';
                            labelToUse = '' + label;

                            if (bidderId) {
                                labelToUse += '-' + bidderId;
                            }

                            analytics = getGAEventAnalytics(action, 'Navigation', labelToUse);
                            return _context33.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 7:
                        case 'end':
                            return _context33.stop();
                    }
                }
            }, _callee33, undefined);
        }));

        return function (_x67, _x68) {
            return _ref34.apply(this, arguments);
        };
    }();
};

var trackTrendingItemClick = exports.trackTrendingItemClick = function trackTrendingItemClick(itemId) {
    return function () {
        var _ref35 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee34(dispatch, getState) {
            var state, _getItem2, catalogId, _getCatalog3, sellerId, bidderId, action, label, analytics;

            return _regenerator2.default.wrap(function _callee34$(_context34) {
                while (1) {
                    switch (_context34.prev = _context34.next) {
                        case 0:
                            state = getState();
                            _getItem2 = (0, _item.getItem)(state, itemId), catalogId = _getItem2.catalogId;
                            _getCatalog3 = (0, _catalog.getCatalog)(state, catalogId), sellerId = _getCatalog3.sellerId;
                            bidderId = (0, _user.getBidderId)(state);
                            action = 'Clicked Homepage Trending Items Module';
                            label = 'Trending-Items-' + itemId + '-' + sellerId;

                            if (bidderId) {
                                label += '-' + bidderId;
                            }

                            analytics = getGAEventAnalytics(action, 'Navigation', label);
                            return _context34.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 9:
                        case 'end':
                            return _context34.stop();
                    }
                }
            }, _callee34, undefined);
        }));

        return function (_x69, _x70) {
            return _ref35.apply(this, arguments);
        };
    }();
};

var trackUpcomingCatalogClick = exports.trackUpcomingCatalogClick = function trackUpcomingCatalogClick(catalogId) {
    return function () {
        var _ref36 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee35(dispatch, getState) {
            var state, _getCatalog4, catalogStatus, sellerId, bidderId, status, action, label, analytics;

            return _regenerator2.default.wrap(function _callee35$(_context35) {
                while (1) {
                    switch (_context35.prev = _context35.next) {
                        case 0:
                            state = getState();
                            _getCatalog4 = (0, _catalog.getCatalog)(state, catalogId), catalogStatus = _getCatalog4.catalogStatus, sellerId = _getCatalog4.sellerId;
                            bidderId = (0, _user.getBidderId)(state);
                            status = catalogStatus === 'online' ? 'upcoming' : catalogStatus;
                            action = 'Clicked Homepage Live and Upcoming Auctions Module';
                            label = status + '-' + catalogId + '-' + sellerId;

                            if (bidderId) {
                                label += '-' + bidderId;
                            }

                            analytics = getGAEventAnalytics(action, 'Navigation', label);
                            return _context35.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 9:
                        case 'end':
                            return _context35.stop();
                    }
                }
            }, _callee35, undefined);
        }));

        return function (_x71, _x72) {
            return _ref36.apply(this, arguments);
        };
    }();
};

var recordAttributionAnalytics = exports.recordAttributionAnalytics = function recordAttributionAnalytics(data) {
    return {
        meta: {
            analytics: {
                eventPayload: {
                    properties: {
                        attribution_bidderId: data.bidderId,
                        attribution_campaign: data.campaign,
                        attribution_content: data.content,
                        attribution_keyword: data.keyword,
                        attribution_medium: data.medium,
                        attribution_source: data.source,
                        attribution_touchdate: data.touchDate,
                        nonInteraction: 1,
                        should_store_in_db: true
                    }
                },
                eventType: _reduxSegment.EventTypes.track
            }
        },
        payload: {},
        type: TRACK_ATTRIBUTION_DATA
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/analytics.js
// module id = yxCd
// module chunks = 46